import scssVariables from "@/assets/styles/variables.module.scss"
import { BaseTheme } from "@shared/theme"
import { embedFont } from "@/lib/fonts"
import { MVT_SELECTORS } from "@/lib/globals"

class PWATheme extends BaseTheme {
  constructor() {
    super()
    this.set("--card-shadow", scssVariables["box-shadow--small"])
  }

  insert() {
    const existingTheme = document.querySelector(
      `[data-mvt="${MVT_SELECTORS.THEME}"]`
    )

    if (existingTheme) {
      existingTheme.innerHTML = this.toString()
    } else {
      const el = document.createElement("style")

      el.type = "text/css"
      el.dataset.mvt = MVT_SELECTORS.THEME

      el.appendChild(document.createTextNode(this.toString()))
      document.head.appendChild(el)
    }
  }

  toString() {
    let css = ":root {\n"

    Object.keys(this.options).forEach(key => {
      css += `${key}: ${this.options[key]};\n`
    })

    css += "}"

    return css
  }

  rbgToVals(rgb) {
    return rgb.replace(/rgb\(/, "").replace(")", "")
  }

  applyThemeParams(themeParams) {
    super.applyThemeParams(themeParams, { scssVariables })

    if (themeParams.body_font) {
      embedFont(themeParams.body_font)
    }

    if (themeParams.heading_font) {
      embedFont(themeParams.heading_font)
    }
  }
}

export default themeParams => {
  const theme = new PWATheme()
  const { default_color_mode } = themeParams
  const isDark = default_color_mode === "dark"

  theme.applyThemeParams(themeParams)

  if (isDark) {
    document.body.classList.add("--dark-mode")
  } else {
    document.body.classList.remove("--dark-mode")
  }

  // Tier 2 switches modes on this attribute (ADR 0021 §6), which is not the body
  // class the rest of the app switches on, so a tier-2 sheet sees the flip too.
  if (isDark) {
    document.documentElement.setAttribute("data-mvt-mode", "dark")
  } else {
    document.documentElement.removeAttribute("data-mvt-mode")
  }

  theme.insert()
}
